import _ from 'lodash';
import { createGraphQlDataAccessStore, QueryParameters } from '@wemogy/reactbase';
import { types } from 'mobx-state-tree';
import GraphQlApiServiceFactory from '../api/graphQl/GraphQlApiServiceFactory';
import RoleDtoMapper from '../mappers/dtoMappers/RoleDtoMapper';
import Role from '../models/Role';
var RoleStoreBaseType = createGraphQlDataAccessStore(Role, GraphQlApiServiceFactory.roleService, new RoleDtoMapper(), QueryParameters.create());
var tenantRolesQueryKey = 'tenantRoles';
var RoleStoreSubType = types.model()
    .named('RoleStoreSubType');
var RoleStore = types.compose(RoleStoreBaseType, RoleStoreSubType)
    .named('RoleStore')
    .views(function (self) { return ({
    getTenantRoles: function () {
        if (0 < 5) {
            return _.orderBy(self.items, function (x) { return x.name; });
        }
        var queryView = self.getQueryView(tenantRolesQueryKey);
        if (!queryView) {
            return [];
        }
        return queryView.allItems;
    }
}); })
    .actions(function (self) { return ({
    queryTenantRoles: function (tenantId) {
        console.log('Query ', tenantId);
        self.query();
        // self.putQueryView(tenantRolesQueryKey, QueryParameters.create().putFilter('tenantId', tenantId, 'equals'))
    }
}); });
export default RoleStore;
//# sourceMappingURL=RoleStore.js.map